import React from "react";
import { stringToKebabCase } from "../../../../../helpers/StringHelper";
import { ShowPart } from "../Page";
import { downloadPartStepFile } from "../../../../../helpers/DownloadHelper";
import ContactCta from "./ContactCta";
import Table from "../../../../../components/vention_ui/shared_components/Table";

interface Props {
  part: ShowPart;
}

const TechnicalDocuments: React.FC<Props> = ({ part }) => {
  const technicalDrawingRows: React.ReactNode[][] = [];

  if (!part.hide_drawing_2d_file && part.pdf_availability) {
    technicalDrawingRows.push([
      "2D Model",
      <a
        href={`/parts/${part.id}/download_pdf`}
        className="product-viewer-v2__text-link"
        data-analytic-id="part-page-2d-drawing-link"
      >
        Download
      </a>,
    ]);
  }

  if (part.step_availability) {
    technicalDrawingRows.push([
      "3D Model",
      <button
        className="product-viewer-v2__text-link"
        onClick={() => downloadPartStepFile(part.id)}
      >
        Download
      </button>,
    ]);
  }

  const techDocConnectionRows: React.ReactNode[][] =
    part.tech_doc_connections.map((technicalDocument) => [
      technicalDocument.label,
      <a
        className="product-viewer-v2__text-link"
        href={technicalDocument.url}
        target="_blank"
        data-analytic-id={`part-page-${stringToKebabCase(technicalDocument.label)}-link`}
      >
        View
      </a>,
    ]);

  const legacyTechnicalDocumentRows: React.ReactNode[][] =
    part.legacy_technical_documents.map((technicalDocument) => [
      technicalDocument.name,
      <a
        className="product-viewer-v2__text-link"
        href={technicalDocument.path}
        target="_blank"
        data-analytic-id={`part-page-${stringToKebabCase(technicalDocument.name)}-link`}
      >
        View
      </a>,
    ]);

  const partDocuments = part.part_documents.map((partDocument) => [
    partDocument.title,
    <a
      className="product-viewer-v2__text-link"
      href={partDocument.file_url}
      target="_blank"
      data-analytic-id={`part-page-${stringToKebabCase(partDocument.title)}-link`}
    >
      View
    </a>,
  ]);

  const partCalculators = part.calculators.map((calculator) => [
    calculator.name,
    <a
      className="product-viewer-v2__text-link"
      href={calculator.url}
      target="_blank"
      data-analytic-id={calculator.analytic_id}
    >
      View
    </a>,
  ]);

  const allTechnicalDocuments = [
    ...techDocConnectionRows,
    ...legacyTechnicalDocumentRows,
    ...partDocuments,
    ...partCalculators,
  ];

  const hasResults =
    technicalDrawingRows.length > 0 || allTechnicalDocuments.length > 0;

  return (
    <section
      id="technical-documents"
      className="product-viewer-v2__technical-documents"
    >
      {hasResults && (
        <>
          {technicalDrawingRows.length > 0 && (
            <Table
              hiddenHeaders={["Technical Drawing"]}
              headers={["Technical Drawing", ""]}
              data={[...technicalDrawingRows]}
            />
          )}

          {allTechnicalDocuments.length > 0 && (
            <Table
              hiddenHeaders={["Technical Documentation"]}
              headers={["Technical Documentation", ""]}
              data={[...allTechnicalDocuments]}
            />
          )}
        </>
      )}

      <ContactCta hasResults={hasResults} />
    </section>
  );
};

export default TechnicalDocuments;
